import React, { Fragment, useEffect, useState } from 'react'

import { connect } from 'react-redux';
import { logout } from '../../actions/auth';
import imgs from '../../utils/images';

import PropTypes from 'prop-types';
import Sidebar from '../layout/Sidebar'
import { Link } from 'react-router-dom';
import { getApplicationsCount, getLastestApplications } from '../../actions/appointments'
// import Spinner from '../layout/Spinner';
import moment from "moment";
import DataTable from 'react-data-table-component';

import ExpandedComponent from '../client_dashboard/appointments/ExpandedComponent';


const columns = [
    {
        name: '',
        selector: row => 'BID' + row.id,
        sortable: true,
    },
    {
        name: '',
        selector: row => moment(row.book_date).format('ddd, D MMM YYYY') + ' ' + row.book_time,
        sortable: true,
    },
    {
        name: '',
        selector: row => row.firstName + ' ' + row.lastName,
        sortable: true,
    },

];

const customStyles = {
    header: {
        style: {
            minHeight: '56px',
        },
    },
    headRow: {
        style: {
            display: 'none'

        },
    },
    headCells: {
        style: {

        },
    },
    cells: {
        style: {

            '&:nth-of-type(2)': {
                minWidth: '60px',
                maxWidth: '80px'
            }
        },
    },
};
const Dashboard = ({ getApplicationsCount, getLastestApplications, client_appointments: { appointments, appointment, loading } }) => {

    const [appliCount, setAppliCount] = useState("0");
    const rowPreExpanded = row => row.defaultExpanded;
    useEffect(() => {
        getApplicationsCount();
    }, [getApplicationsCount]);


    useEffect(() => {
        getLastestApplications();
    }, [getLastestApplications]);

    useEffect(() => {
        if (appointment)
            setAppliCount(appointment.cnt);
    }, [appointment]);

    return (
        <Fragment>
            <div className='wrapper'>
                <Sidebar />
                <div className='servicePage'>
                    <div className='serviceHeader'>
                        <div className='d-flex justify-content-between p-3'>
                            <h2 className='fw-400'>Dashboard</h2>
                        </div>
                    </div>
                    <section className="p-5" id="dashboard_analysis">
                        <div className="container">
                            <div className="row">
                                <div className="col-md-3">
                                    <Link to='/appointments' className="card p-5 text-decoration-none text-dark position-relative">
                                        <img src={imgs.services_grey_icon} alt="" width="20px" className='position-absolute card_icon' />
                                        <div className="card-body text-center">
                                            <h2>{appliCount}</h2>
                                            <p>Appointments</p>
                                        </div>
                                    </Link>
                                </div>
                                <div className="col-md-3">
                                    <Link to="/catalogue/services" className="card p-5 text-decoration-none text-dark position-relative">
                                        <img src={imgs.appointment_grey_icon} alt="" width="20px" className='position-absolute card_icon ' />
                                        <div className="card-body text-center">
                                            <h2>10</h2>
                                            <p>Services</p>
                                        </div>
                                    </Link>
                                </div>
                                <div className="col-md-3"></div>
                                <div className="col-md-3"></div>
                            </div>
                            <div className="row">
                                <div className="col-md-6">
                                    <div className='mt-5 border'>
                                        <div className="p-3 bg-light border-bottom"><h5 className='fw-bold'>UPCOMING APPOINTMENTS</h5></div>
                                        <DataTable columns={columns} data={appointments} customStyles={customStyles} expandableRows
                                            expandableRowExpanded={rowPreExpanded} expandableRowsComponent={ExpandedComponent}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                </div>
            </div >
        </Fragment >

    );
}
Dashboard.propTypes = {
    logout: PropTypes.func.isRequired,
    auth: PropTypes.object.isRequired,
    getApplicationsCount: PropTypes.func.isRequired,
    getLastestApplications: PropTypes.func.isRequired,
}
const mapStateToProps = state => ({
    auth: state.auth,
    client_appointments: state.appointments,
});


export default connect(mapStateToProps, { getApplicationsCount, getLastestApplications, logout })(Dashboard);
